import { Add, Remove } from "@mui/icons-material";
import { IconButton, TextField, type TextFieldProps, styled } from "@mui/material";

export function StepInput({
    onUpdate,
    value,
    disabled,
    ...rest
}: TextFieldProps & { onUpdate: (x: number) => void }): JSX.Element {

    return (
        <StyledTextInput
            disabled={disabled}
            variant="standard"
            aria-label="Step"
            helperText={false}
            value={value}
            slotProps={{
                input: {
                    disableUnderline: true,
                    "aria-label": "Step",
                    startAdornment: (
                        !disabled ? <IconButton
                            aria-label="Minus"
                            size="medium"
                            onClick={() => onUpdate((value as number) - 1)}
                        >
                            {<Remove />}
                        </IconButton> : <></>
                    ),
                    endAdornment: (
                        !disabled ? <IconButton
                            aria-label="Plus"
                            size="medium"
                            onClick={() => onUpdate((value as number) + 1)}
                        >
                            {<Add />}
                        </IconButton> : <></>
                    ),
                }
            }}
            onChange={e => onUpdate(Number.parseInt(e.target.value) as number)}
            {...rest}
        />
    );
}

const PREFIX = "RaStepInput";

const StyledTextInput = styled(TextField, {
    name: PREFIX,
    overridesResolver: (_, styles) => styles.root,
})({
    "& .MuiOutlinedInput-root": {
        paddingRight: 0,
        paddingLeft: 0,
    },
    "& .MuiOutlinedInput-input": {
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
    },
});
